module.exports = require("@wildboar/x500/src/lib/modules/DSAOperationalAttributeTypes/specificKnowledge.oa");